import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { useEffectOnce } from 'react-use';

import { DefaultRoute } from '../DefaultRoute';

import { Coupons } from '../../screens/Coupons';
import { Orders } from '../../screens/Orders';
import { Profile } from '../../screens/Profile';
import { RegisterWarranty } from '../../screens/RegisterWarranty';
import { ResetPassword } from '../../screens/ResetPassword';
import { SignUp } from '../../screens/SignUp';
import { Warranty } from '../../screens/Warranty';

import { getUser } from '../../selectors/user';

import { getUserDataRequest } from '../../actions/user';

export const Router = () => {
  const dispatch = useDispatch();
  const user = useSelector(getUser);

  useEffectOnce(() => {
    if (user.signedIn) {
      dispatch(getUserDataRequest());
    }
  });

  if (user.signedIn) {
    return (
      <Routes>
        <Route path={'/'} element={<Profile />} />
        <Route path={'/coupons'} element={<Coupons />} />
        <Route path={'/orders'} element={<Orders />} />
        <Route path={'/warranty'} element={<Warranty />} />
        <Route path={'/warranty/new'} element={<RegisterWarranty />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path={'/'} element={<DefaultRoute />} />
      <Route path={'/reset-password'} element={<ResetPassword />} />
      <Route path={'/sign-up'} element={<SignUp />} />
    </Routes>
  );
};
